import Marquee from "react-fast-marquee";

const WORDS = ["Transport", "Immobilier", "Construction", "Marketplace", "Prière & Coran", "BTP", "Livraison", "Hajj & Omra", "Rénovation", "Artisans", "Mobilité", "Annonces"];

export const MarqueeStrip = () => (
  <section data-testid="marquee-strip" className="border-y border-border bg-secondary py-8">
    <Marquee speed={40} gradient={false} autoFill>
      {WORDS.map((w, i) => (
        <div key={i} className="flex items-center">
          <span className="font-display text-2xl sm:text-3xl font-medium text-navy/25 px-8">{w}</span>
          <span className="h-1.5 w-1.5 rounded-full bg-navy/20" />
        </div>
      ))}
    </Marquee>
  </section>
);
